<template>
  <nav v-if="visible" class="pi-chat-back" aria-label="Atalho para o chat" @keydown.esc="hide">
    <router-link class="pi-chat-back__link" :to="target">
      <span class="pi-chat-back__label"><span aria-hidden="true">← </span>Voltar ao chat</span>
      <span v-if="summary" class="pi-chat-back__question">{{ summary }}</span>
    </router-link>
    <button type="button" class="pi-chat-back__close" aria-label="Esconder o atalho para o chat" title="Esconder (Esc)" @click="hide">×</button>
  </nav>
</template>

<script>
import { backFromQuery, chatBackVisible, chatReturnRoute, isChatPath } from "./piAssistantModel.js";
import { isPiPath } from "./piAvailability.js";
import { chatState, updateChatState } from "./piChatSession.js";

export default {
  name: "pi-chat-return",
  data() {
    return { back: null };
  },
  computed: {
    path() {
      return this.$route && typeof this.$route.path === "string" ? this.$route.path : "";
    },
    visible() {
      return chatBackVisible(this.back, this.path);
    },
    target() {
      return chatReturnRoute(this.back);
    },
    summary() {
      return this.back ? this.back.question : "";
    },
  },
  watch: {
    "$route"() {
      this.sync();
    },
  },
  created() {
    this.sync();
  },
  methods: {
    sync() {
      const state = chatState();
      if (!isPiPath(this.path) || isChatPath(this.path)) {
        if (state.back) updateChatState({ back: null });
        this.back = null;
        return;
      }
      const back = state.back || backFromQuery(state, this.$route ? this.$route.query : null);
      if (back && back !== state.back) updateChatState({ back: back });
      this.back = back;
    },
    hide() {
      const state = chatState();
      const back = state.back ? Object.assign({}, state.back, { hidden: true }) : null;
      if (back) updateChatState({ back: back });
      this.back = back;
    },
  },
};
</script>

<style scoped>
.pi-chat-back {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 1030;
  display: inline-flex;
  align-items: stretch;
  max-width: calc(100vw - 32px);
  border-radius: 22px;
  background: #1b59f8;
  box-shadow: 0 4px 14px rgba(17, 24, 39, 0.28);
}

.pi-chat-back__link {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  max-width: 360px;
  padding: 8px 6px 8px 16px;
  border-radius: 22px 0 0 22px;
  color: #ffffff;
  text-decoration: none;
}

.pi-chat-back__link:hover,
.pi-chat-back__link:focus {
  color: #ffffff;
  text-decoration: none;
  background: #1340b5;
}

.pi-chat-back__label {
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}

.pi-chat-back__question {
  overflow: hidden;
  font-size: 11px;
  color: #dbe5ff;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pi-chat-back__close {
  width: 34px;
  border: 0;
  border-left: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 0 22px 22px 0;
  background: transparent;
  color: #ffffff;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.pi-chat-back__close:hover,
.pi-chat-back__close:focus {
  background: #1340b5;
}

.pi-chat-back__link:focus,
.pi-chat-back__close:focus {
  outline: 2px solid #ffbf47;
  outline-offset: 2px;
}

@media print {
  .pi-chat-back {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piChatReturn.vue